module.exports = __webpack_public_path__ + "img/1122.30f4c8fc.gif";